export default __webpack_public_path__ + "static/media/filter.4360be1d.svg";